/**
 * <recipe-note> — mobile placement for sections/recipe-note.liquid.
 *
 * The template prints this section after the recipe video, and the video
 * section itself follows the whole recipe body. On a phone that puts the
 * note under the per-serve, shop and newsletter cards. The mobile frame
 * wants steps, video, note, then the author card, then those cards.
 *
 * Below 769px the panel is moved to the end of .recipe-body__main, after the
 * video when that player has already parked itself there, otherwise after
 * the Method. From 769px up it returns to this section, under the
 * two-column body. The move is undone before a theme-editor reload removes
 * the original wrapper.
 */
if (!customElements.get('recipe-note')) {
  customElements.define(
    'recipe-note',
    class RecipeNote extends HTMLElement {
      constructor() {
        super();
        this.onLayoutChange = this.onLayoutChange.bind(this);
        this.onSectionUnload = this.onSectionUnload.bind(this);
      }

      connectedCallback() {
        this.home = this.parentNode;
        this.section = this.home?.closest?.('.shopify-section') ?? null;
        this.layoutQuery = window.matchMedia('(max-width: 768px)');
        this.layoutQuery.addEventListener('change', this.onLayoutChange);
        this.section?.addEventListener('shopify:section:unload', this.onSectionUnload);
        this.place();
      }

      disconnectedCallback() {
        this.layoutQuery?.removeEventListener('change', this.onLayoutChange);
        this.section?.removeEventListener('shopify:section:unload', this.onSectionUnload);
      }

      onLayoutChange() {
        this.place();
      }

      onSectionUnload(event) {
        if (event.target !== this.section) {
          return;
        }

        this.restore();
      }

      place() {
        if (!this.home) {
          return;
        }

        if (!this.layoutQuery.matches) {
          this.restore();
          return;
        }

        const video = document.querySelector('.recipe-body__main > .recipe-video');
        const method = document.querySelector('.recipe-body__method');
        const anchor = video || method;

        if (!anchor || anchor.nextElementSibling === this) {
          return;
        }

        anchor.after(this);
      }

      restore() {
        if (!this.home || this.parentNode === this.home) {
          return;
        }

        this.home.append(this);
      }
    },
  );
}
